import axios from "axios";
import { EllieCenterUser, SignInData, SignInDataGoogle, User } from "../types/user";
import { jwtDecode } from "jwt-decode";

const baseUrl = process.env.REACT_APP_API_HOST;

axios.defaults.baseURL = baseUrl;

export const decodeOperatorJWT = (token: string) => {
  try {
    const decoded = jwtDecode(token);
    return decoded as EllieCenterUser;
  } catch (error) {
    throw new Error("JWT inválido");
  }
};

export async function postLogin({ email, password }: SignInData) {
  const resp = await axios.post("ec/user/login", { email, password });
  return resp.data;
}

export async function postLoginV2({ email, password }: SignInData) {
  const resp = await axios.post("app/v3/bo/login", { email, password });
  return resp.data;
}

export async function getPermissions({ id }: User) {
  const resp = await axios.get(`ec/v2/profile/${id}`);
  return resp.data;
}

export async function postLoginProvider({ email }: SignInDataGoogle) {
  const resp = await axios.post("app/v3/bo/login_provider", { email });
  return resp.data;
}

export async function refreshToken(): Promise<string> {
  const resp = await axios.post("v4/refresh");
  return resp.data.jwt;
}